import React from 'react'
import { CustomerChartBMI, CustomerChartHeight, CustomerChartWeight } from './CustomerChart';
import HeaderPrint from "../../print/HeaderPrint";
import { Col, Label, Row, Table } from 'reactstrap';
import moment from 'moment';
import CalcUtils from "../../../helpers/CalcUltils";
import { relative } from 'path';
const CustomerChartPrint = (props: any) => {
    const { componentRef, patient, customer, years, months, days, user, data, print , width } = props

    const getFullAddressHeader = () => {
        const address = [
            user?.branch_id?.street,
            user?.branch_id?.wards_code?.name,
            user?.branch_id?.district_code?.name,
            user?.branch_id?.provinces_code?.name,
        ];
        return address?.filter((e: any) => e != null)?.join(", ");
    };
    let h: number = 1;
    let w: number = 1;
    let b: number = 1;

    const CustomerChartHeight_print = () => {
        return (
            <div className="content__print">
                {
                    <div>
                        <CustomerChartHeight
                            patient={patient}
                            customer={customer}
                            diff={{
                                years: years,
                                months: months,
                                days: days,
                            }}
                        />
                    </div>
                     &&
                    <div className="content__print">
                        <HeaderPrint
                            data={{
                                branch: user?.branch_id?.name || '---',
                                address: getFullAddressHeader() || '---',
                                phone: user?.branch_id?.hotline || '---',
                                email: user?.branch_id?.email || '---'
                            }}
                        />
                        <div
                            style={{
                                textAlign: "center",
                                fontSize: "23px",
                                fontWeight: "600",
                                color: "#000000",
                                marginTop: "25px",
                            }}
                        >
                            BIỂU ĐỒ THEO DÕI TĂNG TRƯỞNG 
                        </div>
                        <div className="p-5 info-box">
                            <div className="item font_size_18">
                                <Row>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 160px' }}>Khách hàng:</Label>
                                            <div className="font_size_18">{data?.name || "---"}</div>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 145px' }}>Mã khách hàng:</Label>
                                            <div className="font_size_18">
                                                {data?.code || "---"}
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 145px' }}>Ngày sinh:</Label>
                                            <div className="font_size_18">
                                                {moment(data?.birthday).format("DD/MM/YYYY") || "---"}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div> 
                            <div className="item font_size_18">
                                <Row>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 160px' }}>Người bảo hộ:</Label>
                                            <div className="font_size_18">
                                                {data?.customer_guardians?.map((item: any) => (
                                                    <div key={item?.id} className="font_size_18">
                                                        {item?.name || "---"}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 145px' }}>CMT/CCCD:</Label>
                                            {data?.customer_guardians?.map((item: any) => (
                                                <div key={item?.id} className="font_size_18">
                                                    {item?.cccd || "---"}
                                                </div>
                                            ))}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <div className="font_size_18">
                                                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
                                                (
                                                {data?.birthday
                                                    ? CalcUtils.calculateAge(data?.birthday)
                                                    : "---"}
                                                )
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="item font_size_18">
                                <Row>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 160px' }}>Số điện thoại:</Label>
                                            <div className="font_size_18">{data?.phone || "---"}</div>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 145px' }}>Địa chỉ:</Label>
                                            {data?.street || "---"}, {data?.wards_code?.label || "---"}, {data?.district_code?.label || "---"}, {data?.provinces_code?.label || "---"}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 125px' }}>Thời gian in :</Label>
                                            <div className="font_size_18">  {new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })} {new Date().toLocaleDateString('en-GB')}</div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div  >
                                <h5>Bảng chú thích</h5>
                                <div className="item mt-2">
                                    <Row style={{ fontSize: "18px" }}>
                                        <Col md={7}>
                                            <Table className='border_print'>
                                                <tbody>
                                                    <tr style={{ backgroundColor: "#F4F6F8", color: "black", fontWeight: "bold" }}>
                                                        <td>Điểm</td>
                                                        <td>Thời gian cập nhật</td>
                                                        <td>Tuổi : Tháng</td>
                                                        <td>Chiều cao (cm)</td>
                                                    </tr>
                                                    {data?.data?.examinations?.map((item: any, index: any) => {
                                                        if (item?.height && item.height != 6) {
                                                            return (
                                                                <tr style={{ fontWeight: "bold", color: "black" }} key={index}>
                                                                    <td>{h++ ||  "---"}</td>
                                                                    <td>{moment(item.updated_time).format("HH:mm DD/MM/YYYY") || "---"}</td>
                                                                    <td>
                                                                        {item?.updated_time && data?.birthday ? (
                                                                            <>
                                                                                {`${moment(item.updated_time).diff(data.birthday, 'years')}`}:
                                                                                {`${moment(item.updated_time).diff(data.birthday, 'months') % 12}`}
                                                                            </>
                                                                        ) : '---'}
                                                                    </td>
                                                                    <td>{item?.height || "---"}</td>
                                                                </tr>
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>
                        <div className="page-break"></div>
                        <div className="item p-4" >
                            <CustomerChartHeight    
                                width = {width}
                                type={print}
                                patient={patient}
                                customer={customer}
                                diff={{
                                    years: years,
                                    months: months,
                                    days: days,
                                }}
                            />
                        </div>
                    </div>
                }
            </div>
        )
    }

    const CustomerChartWeight_print = () => {
        return (
            <div className="content__print">
                {
                    <CustomerChartWeight
                        patient={patient}
                        customer={customer}
                        diff={{
                            years: years,
                            months: months,
                            days: days,
                        }}
                    /> &&
                    <div className="content__print">
                        <HeaderPrint
                            data={{
                                branch: user?.branch_id?.name || '---',
                                address: getFullAddressHeader() || '---',
                                phone: user?.branch_id?.hotline || '---',
                                email: user?.branch_id?.email || '---'
                            }}
                        />
                        <div
                            style={{
                            textAlign: "center",
                            fontSize: "32px",
                            fontWeight: "600",
                            color: "#000000",
                            marginTop: "20px",
                            marginBottom: "15px",
                            }}
                        >
                            BIỂU ĐỒ THEO DÕI TĂNG TRƯỞNG 
                        </div>
                        <div className=" p-5 info-box">
                            <div className="item font_size_18">
                                <Row>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 160px' }}>Khách hàng:</Label>
                                            <div className="font_size_18">{data?.name || "---"}</div>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 145px' }}>Mã khách hàng:</Label>
                                            <div className="value-text">
                                                {data?.code || "---"}
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 145px' }}>Ngày sinh:</Label>
                                            <div className="value-text">
                                                {moment(data?.birthday).format("DD/MM/YYYY") || "---"}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div> <div className="item font_size_18">
                                <Row>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 160px' }}>Người bảo hộ:</Label>
                                            <div className="value-text">
                                                {data?.customer_guardians?.map((item: any) => (
                                                    <div key={item?.id} className="value-text">
                                                        {item?.name || "---"}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 145px' }}>CMT/CCCD:</Label>
                                            {data?.customer_guardians?.map((item: any) => (
                                                <div key={item?.id} className="value-text">
                                                    {item?.cccd || "---"}
                                                </div>
                                            ))}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <div className="value-text">
                                                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
                                                (
                                                {data?.birthday
                                                    ? CalcUtils.calculateAge(data?.birthday)
                                                    : "---"}
                                                )
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="item font_size_18">
                                <Row>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 160px' }}>Số điện thoại:</Label>
                                            <div className="value-text">{data?.phone || "---"}</div>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 145px' }}>Địa chỉ:</Label>
                                            {data?.street || "---"}, {data?.wards_code?.label || "---"}, {data?.district_code?.label || "---"}, {data?.provinces_code?.label || "---"}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 125px' }}>Thời gian in :</Label>
                                            <div className="value-text">  {new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })} {new Date().toLocaleDateString('en-GB')}</div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="info-box">
                            <h5>Bảng chú thích</h5>
                            <div className="item">
                                <Row>
                                    <Col md={7}>
                                        <Table className='border_print'>
                                            <tr style={{ backgroundColor: "#F4F6F8", color: "black", fontWeight: "bold" }}>
                                                <td>Điểm</td>
                                                <td>Thời gian cập nhật</td>
                                                <td>Tuổi : Tháng</td>
                                                <td>Cân nặng(kg)</td>
                                            </tr>
                                            {data?.data?.examinations?.map((item: any, index: any) => {
                                                if (item?.weight) {
                                                    return (
                                                        <tr style={{ fontWeight: "bold", color: 'black' }} key={index}>
                                                            <td>{w++}</td>
                                                            <td>{item?.updated_time ? moment(item.updated_time).format("HH:mm DD/MM/YYYY") : "---"}</td>
                                                            <td>
                                                                {item?.updated_time && data?.birthday ? (
                                                                    <>
                                                                        {`${moment(item.updated_time).diff(data.birthday, 'years')}`}:
                                                                        {`${moment(item.updated_time).diff(data.birthday, 'months') % 12}`}
                                                                    </>
                                                                ) : '---'}
                                                            </td>
                                                            <td>{item?.weight || "---"}</td>
                                                        </tr>
                                                    );
                                                }
                                                return null;
                                            })}
                                        </Table>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        </div>
                        <div className="page-break"></div>
                        <div className="item p-4">
                            <CustomerChartWeight
                                width = {width}
                                type={print}
                                patient={patient}
                                customer={customer}
                                diff={{
                                    years: years,
                                    months: months,
                                    days: days,
                                }}
                            />
                        </div>
                    </div>
                }
            </div>
        )
    }

    const CustomerChartBMI_print = () => {
        return (
            <div className="content__print">
                {
                    <CustomerChartBMI
                        patient={patient}
                        customer={customer}
                        diff={{
                            years: years,
                            months: months,
                            days: days,
                        }}
                    /> && years >= 5 && years <= 19 &&
                    <div className="content__print">
                        <HeaderPrint
                            data={{
                                branch: user?.branch_id?.name || '---',
                                address: getFullAddressHeader() || '---',
                                phone: user?.branch_id?.hotline || '---',
                                email: user?.branch_id?.email || '---'
                            }}
                        />
                        <div
                            style={{
                            textAlign: "center",
                            fontSize: "32px",
                            fontWeight: "600",
                            color: "#000000",
                            marginTop: "20px",
                            marginBottom: "15px",
                            }}
                        >
                            BIỂU ĐỒ THEO DÕI TĂNG TRƯỞNG 
                        </div>
                        <div className="p-5 info-box">
                            <div className="item">
                                <Row>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 160px' }}>Khách hàng:</Label>
                                            <div className="value-text">{data?.name || "---"}</div>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 145px' }}>Mã khách hàng:</Label>
                                            <div className="value-text">
                                                {data?.code || "---"}
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 145px' }}>Ngày sinh:</Label>
                                            <div className="value-text">
                                                {moment(data?.birthday).format("DD/MM/YYYY") || "---"}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div> <div className="item font_size_18">
                                <Row>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 160px' }}>Người bảo hộ:</Label>
                                            <div className="value-text">
                                                {data?.customer_guardians?.map((item: any) => (
                                                    <div key={item?.id} className="value-text">
                                                        {item?.name || "---"}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 145px' }}>CMT/CCCD:</Label>
                                            {data?.customer_guardians?.map((item: any) => (
                                                <div key={item?.id} className="value-text">
                                                    {item?.cccd || "---"}
                                                </div>
                                            ))}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <div className="value-text">
                                                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
                                                (
                                                {data?.birthday
                                                    ? CalcUtils.calculateAge(data?.birthday)
                                                    : "---"}
                                                )
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="item font_size_18">
                                <Row>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 160px' }}>Số điện thoại:</Label>
                                            <div className="value-text">{data?.phone || "---"}</div>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 145px' }}>Địa chỉ:</Label>
                                            {data?.street || "---"}, {data?.wards_code?.label || "---"}, {data?.district_code?.label || "---"}, {data?.provinces_code?.label || "---"}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="item-sub">
                                            <Label className="mr-0" style={{ flex: '0 0 125px' }}>Thời gian in :</Label>
                                            <div className="value-text">  {new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })} {new Date().toLocaleDateString('en-GB')}</div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="info-box">
                                <h5>Bảng chú thích</h5>
                                <div className="item">
                                    <Row>
                                        <Col md={7}>
                                            <Table className='border_print'>
                                                {/* <body> */}
                                                    <tr style={{ backgroundColor: "#F4F6F8", color: "black", fontWeight: "bold" }}>
                                                        <td>Điểm</td>
                                                        <td>Thời gian cập nhật</td>
                                                        <td>Tuổi : Tháng</td>
                                                    </tr>
                                                    {data?.data?.examinations?.map((item: any, index: any) => {
                                                        if (!item?.weight && !item?.height) {
                                                            return (
                                                                <tr style={{ fontWeight: "bold", color: 'black' }} key={index}>
                                                                    <td>{b++}</td>
                                                                    <td>{item?.updated_time ? moment(item.updated_time).format("HH:mm DD/MM/YYYY") : "---"}</td>
                                                                    <td>
                                                                        {item?.updated_time && data?.birthday ? (
                                                                            <>
                                                                                {`${moment(item.updated_time).diff(data.birthday, 'years')}`}:
                                                                                {`${moment(item.updated_time).diff(data.birthday, 'months') % 12}`}
                                                                            </>
                                                                        ) : '---'}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                                {/* </body> */}
                                            </Table>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>
                        <div className="page-break"></div>
                        <div className="item p-4">
                             <CustomerChartBMI 
                                width = {width}
                                type={print}
                                patient={patient}
                                customer={customer}
                                diff={{
                                    years: years,
                                    months: months,
                                    days: days,
                                }}
                            />
                        </div>
                    </div>
                }
            </div>
        )
    }

    return (
        <div
            className="print-content pre-print rotate_print landscape-print"
            style={{ overflow: "hidden", color: "#000" }}
            ref={componentRef}
        >
            <CustomerChartHeight_print />
            <div className="page-break"></div>
            <CustomerChartWeight_print />
            {
                years >= 5 && years <= 19 && (
                    <>
                        <div className="page-break"></div>
                        <CustomerChartBMI_print />
                    </>
                ) 
            }
            
        </div>
    )
}
export default CustomerChartPrint